import script from "./ReviewAuthor.vue?vue&type=script&setup=true&lang=ts"
export * from "./ReviewAuthor.vue?vue&type=script&setup=true&lang=ts"

import "./ReviewAuthor.vue?vue&type=style&index=0&id=51632266&scoped=true&lang=scss"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-51632266"]])

export default __exports__